// Library imports
import React, { useState } from "react";
import { Router } from "@reach/router";
import { Toast } from "react-bootstrap";

// React Component imports
import MyNavbar from "components/Navbar";
import Footer from "components/Footer";
import Home from "screens/Home";
import TeacherHome from "teach/TeacherHome";
import Apply from "teach/Apply";
import Learn from "screens/Learn";
import LiveStream from "screens/LiveStream";
import Vod from "screens/Vod";
import Login from "screens/Login";
import CourseDetails from "screens/CourseDetails";
import CourseClassList from "screens/CourseClassList";
import Terms from "screens/Terms";
import Privacy from "screens/Privacy";
import CheckoutStatus from "payment/CheckoutStatus";

import "./app.scss";

import { AppContext } from "./libs/contextLib";

export const ScrollToTop = ({ children, location }) => {
  React.useEffect(() => window.scrollTo(0, 0), [location.pathname]);
  return children;
};

function App() {
  const [authenticatedUser, authenticateUser] = useState(false);
  const [errorMessage, updateErrorMessage] = useState(null);
  return (
    <div className="App">
      <AppContext.Provider
        value={{ authenticatedUser, authenticateUser, updateErrorMessage }}
      >
        <MyNavbar />
        <Toast
          className="error-toast"
          onClose={() => updateErrorMessage(null)}
          show={errorMessage !== null}
          delay={4000}
          autohide
        >
          <Toast.Header className="bg-dark border border-secondary rounded text-light">
            {errorMessage}
          </Toast.Header>
        </Toast>
        <Router>
          <ScrollToTop path="/">
            <Home path="/" />
            <TeacherHome path="teach" />
            <Apply path="teach/apply" />
            <CourseDetails path=":domain/course/:courseId/details" />
            <CourseClassList path=":domain/course/:courseId/classes" />
            <Learn path="learn" />
            <LiveStream path=":domain/live-stream" />
            <Vod path="vod" />
            <Login path="login" />
            <Terms path="terms" />
            <Privacy path="privacy" />
            <CheckoutStatus path="checkout-status" />
          </ScrollToTop>
        </Router>
        <Footer />
      </AppContext.Provider>
    </div>
  );
}

export default App;
